export const myTipsFields = [
  {
    prefix: '$',
    key: 'totalSales',
    name: 'Total Sales'
  },
  {
    suffix: '%',
    key: 'totalTipPercent',
    name: 'Total Tip Percent'
  },
  {
    prefix: '$',
    key: 'totalTips',
    name: 'Total Tips'
  },
  {
    prefix: '$',
    key: 'oneDineSales',
    name: 'OneDine Sales'
  },
  {
    suffix: '%',
    key: 'oneDineTipPercent',
    name: 'OneDine Tip Percent'
  },
  {
    prefix: '$',
    key: 'oneDineTips',
    name: 'OneDine Tips'
  },
];

export const aboutFields = [
  {
    key: 'store',
    name: 'Store'
  },
  {
    key: 'device',
    name: 'Device'
  },
  {
    key: 'deviceGroup',
    name: 'Device Group'
  },
  {
    key: 'appVersion',
    name: 'App Version'
  },
  {
    key: 'webVersion',
    name: 'Web Version'
  },
  {
    key: 'environment',
    name: 'Environment'
  },
  {
    key: 'forSupport',
    name: 'For Support'
  },
];
